<template>
  <div class="manage-partner">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Danh sách Partner</h6>
          <router-link :to="{ name: 'CreateHomePartner' }">
            <a-button type="primary" class="ml-20">Thêm mới</a-button>
          </router-link>
        </a-row>
      </template>
      <a-table
        :columns="columns"
        :loading="callingAPI"
        :data-source="dataSource"
        :pagination="pagination"
        @change="handleTableChangePage"
        rowKey="id"
      >
        <template slot="image" slot-scope="row">
          <img
            v-if="row.image"
            :src="row.image"
            alt=""
            class="preview-image-table"
          />
        </template>
        <template slot="status" slot-scope="row">
          <a-switch
            v-model="row.status"
            :loading="row.loadingActive"
            @change="handleUpdate(row)"
          />
        </template>
        <template slot="action" slot-scope="row">
          <a-space>
            <router-link
              :to="{ name: 'UpdateHomePartner', params: { id: row.id } }"
            >
              <a-button shape="circle" icon="edit" size="small" />
            </router-link>
            <a-popconfirm
              placement="topRight"
              ok-text="Xóa"
              cancel-text="Hủy"
              @confirm="removeBanner(row)"
            >
              <template slot="title">
                <p>Xóa partner {{ row.name }} ??</p>
              </template>
              <a-button
                type="danger"
                shape="circle"
                icon="delete"
                size="small"
              />
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import {fetchPartner, deletePartner, updatePartner} from '@/services/landing-page/home/partner'
import { replaceUrlResource } from '@/utils/common'
  export default {
    name: 'ManagePartner',
    data() {
      return {
        callingAPI: true,
        dataSource: [],
        columns: [
          {
            title: 'Tên',
            dataIndex: 'name',
            scopedSlots: { customRender: 'title' },
            class: 'font-semibold',
          },
          {
            title: 'Mô tả',
            dataIndex: 'description',
            class: 'font-semibold'
          },
          {
            title: 'Link',
            dataIndex: 'link',
            scopedSlots: { customRender: 'link' },
          },
          {
            title: 'Ảnh',
            scopedSlots: { customRender: 'image' },
            width: 150,
          },
          {
            title: 'Hiển thị',
            scopedSlots: { customRender: 'status' },
            width: 100,
            fixed: "right",
          },
          {
            title: '',
            scopedSlots: { customRender: 'action' },
            width: 50,
            fixed: "right",
          },
        ],

        pagination: {
          current: 0,
          total: 0,
          pageSize: 5
        }
      }
    },
    async beforeMount() {
      await this.loadData()
    },
    methods: {
      async loadData() {
        try {
          this.callingAPI = true
          const params = {
            page: this.pagination.current,
            per_page: this.pagination.pageSize
          }
          const response = await fetchPartner(params)
          this.dataSource = response.data.data.map((d) =>({
            ...d,
            status: d.status === 1,
            loadingActive: false,
            image: replaceUrlResource(d.image)
          }))
          this.pagination.total = response.data.total
          this.callingAPI = false
        } catch (error) {
          console.log(error);
        }
      },

      async handleTableChangePage(pagination) {
        this.pagination.current = pagination.current;
        await this.loadData();
      },

      async handleUpdate(row) {
        const index = this.dataSource.findIndex((r) => r.id === row.id)
        this.dataSource[index].loadingActive = true
        try {
          const data = {
            status: row.status ? 1 : 0,
            _method: 'PUT'
          }
          const response = await updatePartner(row.id, data)
          this.dataSource[index].loadingActive = false
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Cập nhật trạng thái hiển thị thành công.',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Cập nhật trạng thái hiển thị thất bại.',
            });
          }
        } catch (error) {
          this.dataSource[index].loadingActive = false
        }
      },

      async removeBanner(row) {
        try {
          this.callingAPI = true
          const response = await deletePartner(row.id)
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Xóa partner thành công',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Xóa partner thất bại',
            });
          }
          await this.loadData()
          this.callingAPI = false
        } catch (error) {
          this.callingAPI = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>